<div
  class="card chart-card flex-1 d-flex fd-col jc-between ai-stretch"
  [class.hide-vertical-grid-lines]="shouldHideVerticalGridLines"
  [class.hide-horizontal-grid-lines]="shouldHideHorizontalGridLines"
>
  <div class="row-padding chart-header no-padding-bottom" *ngIf="hasRestrictions">
    <suvo-bi-limited-data-banner
      [isTrial]="isTrialing"
      [featureShortCode]="'AGGREGATION'"
      [tags]="[tileInstance?.recipe?.dataSource]"
    ></suvo-bi-limited-data-banner>
  </div>
  <div
    class="row-padding chart-header d-flex flex-wrap jc-between ai-center"
    style="flex: 0 0 64px"
  >
    <suvo-bi-chart-title [title]="tileInstance?.title"></suvo-bi-chart-title>

    <!-- <button mat-icon-button disabled>
      <mat-icon>more_vert</mat-icon>
    </button> -->
    <suvo-bi-tile-filters-select
      *ngFor="let filter of tileInstance?.filterOptions || []"
      [localChartFilter]="filter"
      (filterChanged)="onChartLocalFilterChange($event)"
      [alias]="tileInstance?.recipe?.dataSource"
    ></suvo-bi-tile-filters-select>
  </div>

  <div class="flex-1 d-flex fd-col ai-stretch" style="flex: 1 1 100%">
    <!-- Skeleton Chart -->

    <ng-container *ngIf="isLoading; else chartLoaded">
      <div class="row-padding flex-1 d-flex fd-col ai-stretch">
        <ng-container *ngIf="tileInstance?.chartType?.value === 'pie-chart'; else skeletonBars">
          <suvo-bi-skeleton-pie class="flex-1"></suvo-bi-skeleton-pie>
        </ng-container>
        <ng-template #skeletonBars>
          <suvo-bi-skeleton-bars
            class="flex-1 d-flex fd-col"
            [barCount]="tileInstance?.recipe?.maxGroups ?? 8"
            [direction]="
              tileInstance?.chartType?.value?.includes('horizontal') ? 'horizontal' : 'vertical'
            "
          >
          </suvo-bi-skeleton-bars>
        </ng-template>
      </div>
    </ng-container>
    <ng-template #chartLoaded>
      <ng-container
        *ngIf="chartData?.length; else noDataSection"
        [ngSwitch]="tileInstance?.chartType?.value"
      >
        <!-- Bar Vertical -->
        <div *ngSwitchCase="'bar-vertical'" class="chart-container flex-1 d-flex fd-col ai-stretch">
          <ngx-charts-bar-vertical
            class="chart"
            [scheme]="colorScheme"
            [results]="chartData"
            [gradient]="gradient"
            [xAxis]="showXAxis"
            [yAxis]="showYAxis"
            [showXAxisLabel]="showXAxisLabel"
            [showYAxisLabel]="showYAxisLabel"
            [xAxisLabel]="xAxisLabel"
            [labelFormatting]="formatLabels && labelFormatting"
            [yAxisLabel]="yAxisLabel"
            [barPadding]="barPadding"
            (select)="onSelect($event)"
            (activate)="onActivate($event)"
            (deactivate)="onDeactivate($event)"
          >
          </ngx-charts-bar-vertical>
        </div>

        <!-- Bar Horizontal -->
        <div
          *ngSwitchCase="'bar-horizontal'"
          class="chart-container flex-1 d-flex fd-col ai-stretch"
        >
          <ngx-charts-bar-horizontal
            class="chart"
            [scheme]="colorScheme"
            [results]="chartData"
            [gradient]="gradient"
            [xAxis]="showXAxis"
            [yAxis]="showYAxis"
            [showXAxisLabel]="showXAxisLabel"
            [showYAxisLabel]="showYAxisLabel"
            [xAxisLabel]="xAxisLabel"
            [labelFormatting]="formatLabels && labelFormatting"
            [yAxisLabel]="yAxisLabel"
            [barPadding]="barPadding"
            (select)="onSelect($event)"
            (activate)="onActivate($event)"
            (deactivate)="onDeactivate($event)"
          >
          </ngx-charts-bar-horizontal>
        </div>

        <!-- Pie Chart -->
        <div
          *ngSwitchCase="'pie-chart'"
          class="chart-container d-flex fd-col ai-stretch"
          style="width: 100%; height: 320px; margin: auto"
        >
          <ngx-charts-pie-chart
            class="chart"
            [scheme]="colorScheme"
            [results]="chartData"
            [gradient]="gradient"
            [labels]="labels"
            [doughnut]="doughnut"
            [label]="label"
            [trimLabels]="trimLabels"
            [labelFormatting]="formatLabels && labelFormatting"
            (select)="onSelect($event)"
            (activate)="onActivate($event)"
            (deactivate)="onDeactivate($event)"
          >
          </ngx-charts-pie-chart>
        </div>

        <!-- No such chart type -->
        <suvo-core-error-message
          class="flex-1"
          *ngSwitchDefault
          title="Chart Type Unsupported"
          [message]="tileInstance?.chartType?.value"
        >
        </suvo-core-error-message>
      </ng-container>
      <ng-template #noDataSection>
        <div class="chart-container flex-1 d-flex fd-col ai-stretch">
          <suvo-core-icon-message
            class="flex-1"
            title="No Chart Data"
            [message]="tileInstance?.noDataMessage || 'No data matches these filters.'"
          >
          </suvo-core-icon-message>
        </div>
      </ng-template>
    </ng-template>
  </div>

  <div class="row-padding flex-1" *ngIf="showLegend">
    <!-- Skeleton Legend -->

    <ng-container *ngIf="isLoading; else chartLegend">
      <suvo-bi-skeleton-legend
        [legendCount]="tileInstance?.recipe?.maxGroups ?? 8"
      ></suvo-bi-skeleton-legend>
    </ng-container>
    <ng-template #chartLegend>
      <suvo-bi-chart-legend
        [legend]="legend"
        [colors]="realColors"
        (itemToggled)="updateVisibleChartData(true)"
      ></suvo-bi-chart-legend>
    </ng-template>
  </div>
</div>
